import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div``;
const TickerSelectWrapper = styled.div`
  max-width: 600px;
`;
const DocumentSelectionWrapper = styled.div`
  padding: 36px 0 0 0;
`;

export const NewsDocumentSelection = ({ selectedDocs, onSelect, onRemoveSelect, onAction, prevActionCache }) => {
  const [tickers, setTickers] = React.useState(prevActionCache?.tickers || []);

  return (
    <Wrapper>
      <TickerSelectWrapper></TickerSelectWrapper>
      <DocumentSelectionWrapper></DocumentSelectionWrapper>
    </Wrapper>
  );
};
